<template>
 <div class="formitemcheckbox-wrap">
    <div class="form-block-item form-block-checkbox-item">
      <div class="item" v-for="(item, index) in options" @click="selectHandle(item)">
        <Icon :name="value == item.value ? 'checkbox1' : 'checkbox0'" />
        <span v-html="item.label" />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue';
  import * as Utils from '@/assets/utils';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/components/footer/index.vue';
  import { LOCAL } from '@/assets/lang';

  const emit = defineEmits([ 'change' ]);

  const props = defineProps({
    options: {
      type: Array,
      defaultValue: () => []
    },
    value: {
      type: Number,
      defaultValue: null
    }
  });

  const selectHandle = item => {
    emit('change', item.value == props.value ? null: item.value);
  }
</script>

<style scoped lang="less">
  @import "index.less";
</style>
